function Revealer(element) {

    if (!element) {
        return;
    }

    const _element = element;
    const _isOpen = _element.dataset?.open === 'true' || false;

    const _title = _element.querySelector('[data-revealer-title]');
    const _content = _element.querySelector('[data-revealer-content]');
    
    if (!_title || !_content) {
        return;
    }

    const contentId = _content.id;
    const titleContent = _title.innerHTML;
    const startsOpen = !!_isOpen;
    _content.inert = !startsOpen;

    if (_title.tagName !== 'BUTTON') {
        _title.innerHTML = `
            <button type="button" class="c-revealer__title" aria-controls="${contentId}" aria-expanded="${startsOpen}">
            ${titleContent ?? ''}
            </button>`;
    }

    const titleButton = _title.querySelector('button') ?? _title;

    titleButton?.addEventListener('click', () => {
        // Cast the state as a boolean
        let expanded = titleButton.getAttribute('aria-expanded') === 'true' || false;

        // Switch the state
        titleButton.setAttribute('aria-expanded', !expanded);
        _element.dataset.open = !expanded;
        // Switch the content's visibility
        _content.inert = expanded;    
    }, false);
}

export default Revealer;
